<template>
  <div v-if="content && content.frontendComponent" class="generic">
    <template>
      <mydtm-benefits v-if="content.frontendComponent === 'mydtm-benefits'" :data="content"/>
      <mydtm-preferences v-if="content.frontendComponent === 'mydtm-preferences'" :data="content"/>
      <mydtm-news v-if="content.frontendComponent === 'mydtm-news'" :data="content"/>
    </template>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';
import MydtmBenefits from './generic/MydtmBenefits';
import MydtmPreferences from '@/components/generic/MydtmPreferences';
import MydtmNews from '@/components/generic/MydtmNews';

export default {
  name: 'Generic',
  components: {
    MydtmNews,
    MydtmPreferences,
    MydtmBenefits
  },
  props: {
    id: String
  },
  data () {
    return {
      content: null
    };
  },
  methods: {
    async fetchModuleGeneric () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=moduleGeneric&id=${this.id}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.content = response.moduleGeneric;
        });
    }
  },
  created () {
    if (this.id) {
      this.fetchModuleGeneric();
    }
  }
};
</script>

<style lang="scss" scoped>
.generic {
  color: #333;
}
</style>
